import { ReactNode, Suspense } from "react";
import { ThemeProvider, ThemeProviderScope, ToastsProvider } from "@kaltura/mediaspace-shared-contexts";
import { Config, ConfigProvider } from "@kaltura/mediaspace-shared-data-kms-config";

export type TopLevelComponentWrappersProps = ThemeProviderScope & {
    children: ReactNode;
    context: Config;
};

/**
 * Common contexts and other wrappers for a top-level component.
 */
export const TopLevelComponentWrappers = ({ children, context, ...scopeProps }: TopLevelComponentWrappersProps) => {
    const { theming } = context;

    return (
        <Suspense fallback={<div />}>
            <ConfigProvider context={context}>
                <ThemeProvider {...scopeProps} overrides={theming?.theme} mode={theming?.mode}>
                    <ToastsProvider toastDuration={4000}>{children}</ToastsProvider>
                </ThemeProvider>
            </ConfigProvider>
        </Suspense>
    );
};
